import styled, {css} from "styled-components"
import {greys} from "@irati/ui/src/global/colors"

interface Props {
  image: string,
  compactMode?: boolean,
  color?: string
}

export default styled.div<Props>`
  width: 100%;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  box-shadow: 0 0 0 1px ${greys.light};
  ${({compactMode}) => css`
    height: ${compactMode ? 104 : 148}px;
  `}
  ${({theme}) => css`
    background-color: ${theme.colors.utility.white};
  `}
  ${({color, image}) => {
    if (!image && color) {
      return css`
        background-color: ${color};
      `
    }
    return css`
      background-image: url(${image});
      background-position: center;
      background-size: cover;
    `
  }}
`
